<script setup>
import { defineComponent } from 'vue';

const props = defineProps({
    progress: {
        type: Number,
        required: true,
    },
});
</script>

<template>
    <div class="progress">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" :aria-valuemin="0" :aria-valuemax="100"
            :style="{ width: progress + '%' }">
            {{ progress }}%
        </div>
    </div>
</template>
